import { render, staticRenderFns } from "./PostalCode.vue?vue&type=template&id=0fb6da7e&scoped=true"
import script from "./PostalCode.vue?vue&type=script&lang=js"
export * from "./PostalCode.vue?vue&type=script&lang=js"
import style0 from "./css/postalCode.css?vue&type=style&index=0&id=0fb6da7e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb6da7e",
  null
  
)

export default component.exports